import { render } from "./Patterns.vue?vue&type=template&id=04c51801&scoped=true"
import script from "./Patterns.vue?vue&type=script&lang=js"
export * from "./Patterns.vue?vue&type=script&lang=js"

import "./Patterns.vue?vue&type=style&index=0&id=04c51801&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04c51801"]])

export default __exports__